import { IntegrityMonitorRegistryKeyRuleFormWebComponent } from './component/IntegrityMonitorRegistryKeyRuleFormWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYKEY_FORM } from '../../../../webcomponents.constants';

export { IntegrityMonitorRegistryKeyRuleFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYKEY_FORM,
  IntegrityMonitorRegistryKeyRuleFormWebComponent
);
